import React, { createContext, useState, useContext, useCallback } from 'react';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
    const [notification, setNotification] = useState({ message: '', type: '', onConfirm: null, onCancel: null });
    const [isVisible, setIsVisible] = useState(false);
    const timeoutRef = React.useRef(null);

    // Bildirimi gösteren fonksiyon
    const showNotification = useCallback((message, type, onConfirm, onCancel) => {
        // Önceki timeout'u temizle
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        setNotification({ message, type, onConfirm, onCancel });
        setIsVisible(true);

        // Sadece success ve error tipleri için otomatik kapanma (3 saniye)
        if (type === 'success' || type === 'error') {
            timeoutRef.current = setTimeout(() => {
                setIsVisible(false);
                setNotification({ message: '', type: '', onConfirm: null, onCancel: null });
            }, 3000);
        }
    }, []);

    // Bildirimi kapatmak için fonksiyon
    const hideNotification = useCallback(() => {
        setIsVisible(false);
        setTimeout(() => {
            setNotification({ message: '', type: '', onConfirm: null, onCancel: null });
        }, 300); // fadeOut animasyonu süresiyle eşleşir
    }, []);

    // Onay butonu için işleyici
    const handleConfirm = useCallback(() => {
        if (notification.onConfirm) {
            notification.onConfirm();
        }
        hideNotification();
    }, [notification, hideNotification]);

    // İptal butonu için işleyici
    const handleCancel = useCallback(() => {
        if (notification.onCancel) {
            notification.onCancel();
        }
        hideNotification();
    }, [notification, hideNotification]);

    return (
        <NotificationContext.Provider value={{ showNotification }}>
            {children}
            {isVisible && notification.message && (
                <div className={`notification ${notification.type} notification-global`}>
                    <p className="notification-message">{notification.message}</p>
                    {notification.type === 'confirm' && (
                        <div className="confirm-dialog-buttons">
                            <button className="confirm-dialog-btn confirm" onClick={handleConfirm}>
                                Evet
                            </button>
                            <button className="confirm-dialog-btn cancel" onClick={handleCancel}>
                                Hayır
                            </button>
                        </div>
                    )}
                </div>
            )}
        </NotificationContext.Provider>
    );
};

export const useNotification = () => {
    const context = useContext(NotificationContext);
    if (context === undefined) {
        throw new Error('useNotification must be used within a NotificationProvider');
    }
    return context;
};